export const firebaseConfigTest = {
  apiKey: "AIzaSyCnzDyPxohZHKgYw9Fq8Km5W6k0wCzL2_M",
  authDomain: "vade-mecum-test1.firebaseapp.com",
  databaseURL: "https://vade-mecum-test1.firebaseio.com",
  projectId: "vade-mecum-test1",
  storageBucket: "vade-mecum-test1.appspot.com",
  messagingSenderId: "84361541499"
};

export const firebaseConfig = {
  apiKey: "AIzaSyDLJvGUvCZCOUbVRQp_0-p9NZgQd_0SnK8",
  authDomain: "vade-mecum-app.firebaseapp.com",
  databaseURL: "https://vade-mecum-app.firebaseio.com",
  projectId: "vade-mecum-app",
  storageBucket: "vade-mecum-app.appspot.com",
  messagingSenderId: "596262488012"
};



// WEBPACK FOOTER //
// ./src/firebase.config.ts